module.exports = __webpack_public_path__ + "img/network.13d68b96.svg";